/// <amd-module name="Release/Landing/LeftPanel/PipelineSearch/PipelineSearchActions" />
import { ReleaseDefinition } from "Release/Client/Contracts/Release";
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";

export interface ISearchDefinitionPayload {
    searchText: string;
    searchedDefinitions: ReleaseDefinition[];
    searchResultsLoading: boolean;
}

export class PipelineSearchActions extends ActionsHubBase {
    public static getKey(): string {
        return "release-landing-pipelines-search-actions";
    }

    public initialize(): void {
        this._searchDefinitions = new Action<ISearchDefinitionPayload>();
    }

    public get searchDefinitions(): Action<ISearchDefinitionPayload> {
        return this._searchDefinitions;
    }

    private _searchDefinitions: Action<ISearchDefinitionPayload>;
}
